import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import Header from "components/Header";
import Footer from "components/Footer";

const PrivacyPolicy = () => {
  const [htmlContent, setHtmlContent] = useState("");

  useEffect(() => {
    // Fetch the HTML content
    fetch("/privacy policy.html")
      .then((response) => response.text())
      .then((data) => setHtmlContent(data))
      .catch((error) => console.error("Error loading HTML:", error));
  }, []);

  return (
    <>
      <Helmet>
        <title>Privacy Policy at Zwilling Labs</title>
        <meta
          name="description"
          content="Reach out to Zwilling Labs for cutting-edge digital solutions."
        />
      </Helmet>
      <div
        className="w-full bg-white privacy-policy-container"
        style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}
      >
        {/* Header */}
        <Header className="rounded-bl-[34px] rounded-br-[34px] bg-blue_gray-900" />

        {/* Main Scrollable Content */}
        <main style={{ flexGrow: 1 }}>
          <div
            dangerouslySetInnerHTML={{ __html: htmlContent }}
            style={{
              padding: "15px",
              width: "100%",
            }}
          />
        </main>

        {/* Footer */}
        <Footer className="rounded-tl-[34px] rounded-tr-[34px] bg-gradient1 sm:py-[5%]" />
      </div>
    </>
  );
};

export default PrivacyPolicy;
